import { isNumericalString } from "../is";


export const insert = (obj: Record<string, any>, path: string, value: any, options: {
  insertEmptyArrays?: boolean;
} = {}) => {
  const keys = path.split('.');

  let next = obj;
  while (keys.length > 0 && !!next) {
    const key = keys[0];
    if (!key) break;



    if (options.insertEmptyArrays) {
        // Handle cases when trying to insert into an array with an index.
        // consider `a = key`, so that a.b.c where c is the index.
        const b = keys[1]; // array
                           // .
        const c = keys[2]; // index
        if (typeof next === 'object' && isNumericalString(c)) {
          if (typeof next[b] === 'undefined' || next[b] === null) {
            next[b] = [];
          }
        }
    }

    if (keys.length <= 1) {
      next[key] = value;
      break;
    }
    
    keys.splice(0, 1);
    next = next[key];
  }
}
